import { IFormFieldsMeta, EFieldType } from 'shared/types/Page.interface';
import { FIELD_RULES } from 'shared/constants/validationRules';

// Поля формы для регистрации пользователя
export const REGISTRATION_FORM_FIELDS: IFormFieldsMeta = [
  {
    name: 'lastname',
    label: 'Фамилия',
    type: EFieldType.input,
    required: true,
    placeholder: 'Введите фамилию',
    rules: FIELD_RULES.fullName,
  },
  {
    name: 'firstname',
    label: 'Имя',
    type: EFieldType.input,
    required: true,
    placeholder: 'Введите имя',
  },
  {
    name: 'middleName',
    label: 'Отчество',
    type: EFieldType.input,
    placeholder: 'Введите отчество',
  },
  {
    name: 'company',
    label: 'Название компании',
    type: EFieldType.input,
    required: true,
    placeholder: 'Введите название компании',
    rules: FIELD_RULES.companyName,
  },
  {
    name: 'innCompany',
    label: 'ИНН компании',
    type: EFieldType.input,
    placeholder: 'Введите ИНН компании',
    rules: FIELD_RULES.innField,
  },
  {
    name: 'email',
    label: 'Email',
    type: EFieldType.input,
    required: true,
    placeholder: 'Введите email',
    rules: FIELD_RULES.emailField,
  },
  {
    name: 'comment',
    label: 'Комментарий',
    type: EFieldType.textarea,
    placeholder: 'Дополнительная информация',
    rules: FIELD_RULES.descriptionField,
  },
] as const;
